import React, { Suspense } from 'react'
import Card from 'src/components/Card'
import CardBody from './CardBody'
import { Table } from '@imcva/reactstrap-table'
import { columns } from './columns'

const List: React.FC = () => {
  const suspenseColumns = columns([])
  return (
    <>
      <Card title='Staffing Agencies'>
        <Suspense fallback={<Table options={{ data: [], columns: suspenseColumns }} suspend={3} />}>
          <CardBody />
        </Suspense>
      </Card>
    </>
  )
}

export default List
